import { api } from './authService';

let catalogPromise = null;

/** Role catalog from the backend (`{roles, permissions}`), fetched once per page load. */
export function getRoleCatalog() {
  if (!catalogPromise) {
    catalogPromise = api
      .get('/api/v2/roles')
      .then((res) => res.data)
      .catch((err) => {
        catalogPromise = null;
        throw err;
      });
  }
  return catalogPromise;
}

export const orgMembersService = {
  list(orgId) {
    return api.get(`/api/v2/organizations/${orgId}/members`).then((r) => r.data);
  },
  add(orgId, { email, first_name, last_name, roles }) {
    return api
      .post(`/api/v2/organizations/${orgId}/members`, { email, first_name, last_name, roles })
      .then((r) => r.data);
  },
  setRoles(orgId, userId, roles, extra = {}) {
    const body = Array.isArray(roles) ? { roles, ...extra } : roles;
    return api.put(`/api/v2/organizations/${orgId}/members/${userId}/roles`, body).then((r) => r.data);
  },
  remove(orgId, userId) {
    return api.delete(`/api/v2/organizations/${orgId}/members/${userId}`).then((r) => r.data);
  },
};

/** Label for a role key, from the catalog when available. */
export function roleLabel(catalog, key) {
  const hit = catalog?.roles?.find((r) => r.key === key);
  return hit ? hit.label : key;
}
